import React,{useState,useEffect} from 'react'
import { Accordion, Spinner } from 'flowbite-react'
import axios from 'axios'
export default function CourseFAQ({course_id}) {
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([])
    const [lan, setLan] = useState('bangla')
    const baseURL = "https://mukti-backend-bd.onrender.com"
    const getData = async () => {
        try {
            const res = await axios.get(`${baseURL}/faq/${course_id}`)
            console.log(res.data)
            setData(res.data)
            setLoading(false)
        } catch (e) {
            console.log(e)
        }
    }
    useEffect(() => {
        if (localStorage.getItem('language') === 'english') {
            setLan('english')
        } else {
            setLan('bangla')
        }
        getData()
    }, [])
    //https://www.youtube.com/embed/yAQqeRh0b3Y?autoplay=1&mute=1
    return loading? <Spinner/> : (
        <Accordion className='mx-8'>
            {data.map(a => (<Accordion.Panel>
                <Accordion.Title>
                    {lan=="bangla"?a.title_bangla: a.title}
                </Accordion.Title>
                <Accordion.Content>
                    
                    <p className="text-gray-500 dark:text-gray-400">
                    {lan=="bangla"?a.description_bangla: a.description}
                    </p>
                </Accordion.Content>
            </Accordion.Panel>))}

        </Accordion>
    )
}
